import { BlurredVideoBackground } from '@sparemin/blockhead';
import React, { useRef } from 'react';
import { useEditSceneModalPlaybackContext } from '../EditSceneModalPlaybackContext';
import { useBackgroundBlur, useEditSceneModalStateContext } from '../state';
import useDrawLayout from '../useDrawLayout';
import { block } from '../utils';

export type EditSceneSlotsProps = {};

const EditSceneSlots: React.FC<EditSceneSlotsProps> = () => {
  const { playerRef } = useEditSceneModalPlaybackContext();
  const {
    state: { previewDimensions },
  } = useEditSceneModalStateContext();
  const { isBackgroundBlurEnabled } = useBackgroundBlur();

  const canvasRef = useRef<HTMLCanvasElement>();

  useDrawLayout({ canvasRef });

  return (
    <>
      {isBackgroundBlurEnabled && (
        <BlurredVideoBackground
          width={previewDimensions?.width ?? 0}
          height={previewDimensions?.height ?? 0}
          video={playerRef.current?.dangerousHTMLVideoElement}
        />
      )}
      <canvas
        className={block('preview-canvas')}
        ref={canvasRef}
        width={previewDimensions?.width ?? 0}
        height={previewDimensions?.height ?? 0}
      />
    </>
  );
};

export default EditSceneSlots;
